import parseXML from "../utils/parseXML";
import DataElement from "./DataElement";
import RootElement from "./RootElement";
import { updateViewModel } from "./UpdateViewModel";
import { dataElement2XML, viewModel2XML } from "./ViewModel2XML";


async function xmlResponse2JSON(response) {
  const xmltext = await response.text();
  let parser = new DOMParser ();  
  const result = {
    sequences: {}
  }
  /* 
    <Response>
      <EF_FOERDERANTRAG sequence="68"/>
      <EF_PROJEKT sequence="68"/>
    </Response>
  */
  const root = parser.parseFromString(xmltext, 'text/xml').children[0];
  for (let i = 0; i < root.children.length; i++) {
    let aChild = root.children[i];
    let seq = aChild.getAttribute("sequence");
    if (seq !== null) {
      result.sequences[aChild.localName] = seq;
    }
  }
  return result;
}

export interface WritePathOptions {
  root: RootElement;
  savePath: string;
  dataElement?: DataElement;
}

export interface TransferDataConverter {
  readonly mimeType: string;

  getWritePath: (options: WritePathOptions) => string;
  getWritePWDPath: (options: WritePathOptions) => string;
  convertAllToText: (root: RootElement) => Promise<string>;
  convertElementToText: (root: DataElement) => Promise<string>;
  response2JSON: (root: RootElement, response: Response) => Promise<any>;
  updateViewModel: (data: string, root: RootElement, headers: Headers) => void;
}

export class VueFormsXMLRDBConverter implements TransferDataConverter {

  private writePath: string = "xmlrdb/write";
  private writePWDPath: string = "xmlrdb/writepwd";
  readonly mimeType: string = "application/xml";

  getWritePWDPath(options: WritePathOptions){
    return this.writePWDPath + options.savePath;
  };

  getWritePath(options: WritePathOptions){
    return this.writePath + options.savePath;
  };

  async convertAllToText(root: RootElement ) {
    let serializer = new XMLSerializer();
    let xmlDoc = await viewModel2XML(root);
    let string = serializer.serializeToString(xmlDoc);
    console.debug("Storing ...",string);
    return string;
  }

  async convertElementToText(dataElement: DataElement) {
    let serializer = new XMLSerializer();
    let xmlDoc = await dataElement2XML(dataElement);
    let string = serializer.serializeToString(xmlDoc);
    console.debug("Storing ...",string);
    return string;
  }

  async response2JSON(root: RootElement, response: Response) {
    
    return xmlResponse2JSON(response);
  }

  async updateViewModel(data: string, root: RootElement, headers: Headers) {
    let dataxml = parseXML(data);
    updateViewModel(dataxml, root);
  }
}